export default __webpack_public_path__ + "static/me-471d87cbbc03bf49005a355aae446344.jpg";